class Columna {

    constructor({ id = '', name = '', taskIds = [] } = {}) {
        this.id = id
        this.name = name
        this.taskIds = Array.isArray(taskIds) ? taskIds.map((t) => t.id) : []
        this.tasks = Array.isArray(taskIds) ? taskIds : []
    }

    static from(api) {
        if (!api) return new Columna()
        return new Columna({
            id: api.id ?? '',
            name: api.nombre ?? '',
            taskIds: Array.isArray(api.tareas)
                ? api.tareas : []
        })
    }

    toObject() {
        return {
            id: this.id,
            nombre: this.name,
        }
    }
}

export default Columna;